import React from "react";
import { Modal } from "reactstrap";
import styles from "./styles.module.scss";
import QRCode from "react-qr-code";
import { useAuth } from "providers/auth";
import indexScoreImage from "Assets/images/wearable-modal-index-score.png";
import sleepArchitectureImage from "Assets/images/wearable-modal-sleep-architecture.png";
import { useTranslation } from "lib/i18n/use-translation";

interface BiometricsDeviceConnectionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BiometricsDeviceConnectionModal = ({
  isOpen,
  onClose,
}: BiometricsDeviceConnectionModalProps) => {
  const { learner } = useAuth();
  const { t } = useTranslation(["settings", "biometrics"]);

  const handleClose = () => {
    onClose();
  };

  const { id: user_id } = learner;
  const baseUrl = `${process.env.REACT_APP_UPLOAD_URL}`;

  const hasExperiencedTheAppleHealthConnectionPermissionsIssue =
    learner?.biometrics?.hasExperiencedTheAppleHealthConnectionPermissionsIssue;

  const value = `${baseUrl}users/${user_id}/connect-biometrics`;

  return (
    <Modal
      className={styles["biometrics-modal"]}
      contentClassName={styles["biometrics-modal-content"]}
      isOpen={isOpen}
      toggle={handleClose}
      centered
      style={{ width: "auto", maxWidth: "816px" }}
    >
      <div className={styles["wearable-modal-body"]}>
        <div className={styles["wearable-left-panel"]}>
          <div className={styles["phone-index-score"]}>
            <img src={indexScoreImage} alt="Index Score screen" />
          </div>
          <div className={styles["phone-sleep-architecture"]}>
            <img src={sleepArchitectureImage} alt="Sleep Architecture screen" />
          </div>
        </div>
        <div className={styles["wearable-right-panel"]}>
          <button
            className={styles["wearable-close-button"]}
            onClick={handleClose}
            aria-label="Close"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L13 13M1 13L13 1"
                stroke="#141B34"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {hasExperiencedTheAppleHealthConnectionPermissionsIssue ? (
            <>
              <h1 className={styles["wearable-title"]}>
                {t("settings:wearableModal.reconnectTitle")}
              </h1>
              <p className={styles["wearable-subtitle"]}>
                {t("settings:wearableModal.reconnectSubtitle")}
              </p>
              <p className={styles["wearable-body-text"]}>
                {t("settings:wearableModal.reconnectBody")}
              </p>
            </>
          ) : (
            <>
              <h1 className={styles["wearable-title"]}>
                {t("biometrics:intro.heading")}
              </h1>
              <p className={styles["wearable-subtitle"]}>
                {t("biometrics:intro.subtitle")}
              </p>
              <p className={styles["wearable-body-text"]}>
                {t("biometrics:intro.body")}
              </p>
            </>
          )}
          <div className={styles["wearable-qr-section"]}>
            <div className={styles["qr-code"]}>
              <QRCode value={value} bgColor="transparent" size={64} />
            </div>
            <div className={styles["qr-label"]}>
              <p className={styles["qr-label-title"]}>
                {t("settings:wearableModal.scanToGetStarted")}
              </p>
              <p className={styles["qr-label-instructions"]}>
                {t("settings:wearableModal.qrInstructionsIntro")}
                <br />
                {t("settings:wearableModal.qrInstructionsPath")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BiometricsDeviceConnectionModal;
